module.exports = __webpack_public_path__ + "static/media/icon-aluguel-valorizacao.62b13d26.webp";